import { requireAuth } from '@/router/helpers';

/**
 * FE routes
 */
const FeRoutes = [
    // Groups index
  {
    path: '/usergroups',
    name: 'UserGroupsIndex',
    component: () => import('@/views/UserGroups/Index'),
    beforeEnter: requireAuth,
  },
  {
    path: '/usergroups/member',
    name: 'UserGroupsIndexMember',
    component: () => import('@/views/UserGroups/Index'),
    beforeEnter: requireAuth,
    meta: {memberFilter: true}
  },
  // Create group
  {
    path: '/usergroups/create',
    name: 'UserGroupsCreate',
    components: {
      default: () => import('@/views/UserGroups/Index'),
      panel: () => import('@/views/UserGroups/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: false, openPanel: true },
  },
  // View group
  {
    path: '/usergroups/group/:groupId',
    name: 'UserGroupsSingleView',
    component: () => import('@/views/UserGroups/View'),
    beforeEnter: requireAuth,
  },
  // Edit group
  {
    path: '/usergroups/group/:groupId/edit',
    name: 'UserGroupsEdit',
    components: {
      default: () => import('@/views/UserGroups/Index'),
      panel: () => import('@/views/UserGroups/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: false, openPanel: true },
  },
];

const AdminRoutes = [
  
];

export default [...FeRoutes,...AdminRoutes];
